import * as React from "react";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import Information from "../models/Information";
import ContentLoader, {List} from "react-content-loader";
import dateFormat from "dateformat";

const InformationPage: React.FC = () => {
    const {id} = useParams<{id: string}>();
    const [info, setInformation] = useState<Information>(null);
    const [loadend, setLoadEnd] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        $.ajax(`/api/${id}`, {
            type: 'get',
        }).done((data) => {
            const m: Information = data;
            setInformation(m);
        }).fail((error) => {
            setHasError(true);
        }).always(() => {
            setLoadEnd(true);
        });
    },[]);

    if (!loadend) {
        return (
            <div className={"information-page"}>
                <div>
                    <img src={"/images/header_information.png"} className={"header"} alt={"通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
                </div>
                <div style={{margin: "10px"}}>
                    只今読み込み中です。
                </div>
                <h1>
                    <ContentLoader viewBox={"0 0 300 15"}>
                        {/* @ts-expect-error Async Server Component */}
                        <rect x={"0"} y={"0"} rx={"5"} ry={"5"} width={"200"} height={"14"}/>
                    </ContentLoader>
                </h1>
                <div className={"date"}>
                    <ContentLoader viewBox={"0 0 300 15"}>
                        {/* @ts-expect-error Async Server Component */}
                        <rect x={"200"} y={"0"} rx={"5"} ry={"5"} width={"100"} height={"10"}/>
                    </ContentLoader>
                </div>
                {/* @ts-expect-error Async Server Component */}
                <ContentLoader viewBox={"0 0 300 100"}>
                    <rect x={"0"} y={"0"} rx={"5"} ry={"5"} width={"300"} height={"10"}/>
                    <rect x={"0"} y={"20"} rx={"5"} ry={"5"} width={"300"} height={"10"}/>
                    <rect x={"0"} y={"40"} rx={"5"} ry={"5"} width={"300"} height={"10"}/>
                    <rect x={"0"} y={"60"} rx={"5"} ry={"5"} width={"300"} height={"10"}/>
                </ContentLoader>
                <div className={"backlink"}>
                    <a href={"/"}>戻る</a>
                </div>
            </div>
        );
    }

    if (hasError) {
        return (
            <div className={"information-page"}>
                <div>
                    <img src={"/images/header_information.png"} className={"header"} alt={"通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
                </div>
                <h1>読み込みエラー</h1>
                <div className={"info"}>
                    読み込み中にエラーが発生しました。URLが正しいかご確認下さい。
                </div>
                <div className={"backlink"}>
                    <a href={"/"}>戻る</a>
                </div>
            </div>
        );
    }

    const dateStr = dateFormat(info.date , 'yyyy年mm月dd日')

    return (
        <div className={"information-page"}>
            <div>
                <img src={"/images/header_information.png"} className={"header"} alt={"通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
            <h1>
                {info.title}
            </h1>
            <div className={"date"}>
                投稿日: {dateStr}
            </div>
            <div className={"contents"} dangerouslySetInnerHTML={{__html: info.content}}/>
            <div className={"backlink"}>
                <a href={"/"}>戻る</a>
            </div>
        </div>
    );
}

export default InformationPage;
